export function isRoomCode(value: string) {
  return /^(?:[A-Z]{3}|[A-Z0-9]{6})$/.test(value.toUpperCase());
}

export function primaryHomeAction(roomCode: string) {
  return isRoomCode(roomCode) ? "join" : "create";
}
